"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GetBucketWebsiteInput_1 = require("./GetBucketWebsiteInput");
var GetBucketWebsiteOutput_1 = require("./GetBucketWebsiteOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.GetBucketWebsite = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "GetBucketWebsite",
    http: {
        method: "GET",
        requestUri: "/{Bucket}?website"
    },
    input: {
        shape: GetBucketWebsiteInput_1.GetBucketWebsiteInput
    },
    output: {
        shape: GetBucketWebsiteOutput_1.GetBucketWebsiteOutput
    },
    errors: []
};
//# sourceMappingURL=GetBucketWebsite.js.map